var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotoCoin2White(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.77 9.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #ffffff;\n        stroke-miterlimit: 10;\n        stroke-width: .75px;\n      }\n\n      .cls-2 {\n        fill: #ffffff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.97,2.99c-.15-.04-.3-.07-.45-.07-.86.02-1.37.39-1.51,1.12l-.05.76v2s0,.03-.03.03h-.7s-.03,0-.03-.03v-1.51c0-.31,0-.6-.01-.86,0-.07.01-.25.01-.53.3-1.24,1.17-1.82,2.62-1.74h.05s.06,0,.09,0v.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.52,2.89C1.86,1.46,3.49.38,5.45.38s3.59,1.09,3.93,2.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0,
    y1: 3.72,
    x2: 2.78,
    y2: 3.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0,
    y1: 5.31,
    x2: 2.78,
    y2: 5.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.99,
    y1: 3.68,
    x2: 10.77,
    y2: 3.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.99,
    y1: 5.28,
    x2: 10.77,
    y2: 5.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.38,6.13c-.34,1.43-1.97,2.52-3.93,2.52s-3.59-1.09-3.93-2.52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotoCoin2White);
export default __webpack_public_path__ + "static/media/RotoCoin2white.b14519d87a0d05579d7aae0d870655f1.svg";
export { ForwardRef as ReactComponent };